namespace Matrix.Data {
    export interface ClientTableRow {
        TableSchema?: string;
        Tablename?: string;
        FullName?: string;
        Identifier?: string;
        DisplayName?: string;
        InstanceName?: string;
        ImportedTable?: boolean;
        ReadPermission?: string;
        ModifyPermission?: string;
        IdFieldName?: string;
        NameFieldName?: string;
        DisplayOrderField?: string;
        LookupScript?: boolean;
        LookupPermission?: string;
        NavigationPath?: string;
        NavigationOrder?: number;
        NavigationIcon?: string;
        Extends?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ClientFields?: ClientFieldRow[];
    }

    export namespace ClientTableRow {
        export const idProperty = 'FullName';
        export const nameProperty = 'DisplayName';
        export const localTextPrefix = 'Data.ClientTable';
        export const lookupKey = 'Data.ClientTable';

        export function getLookup(): Q.Lookup<ClientTableRow> {
            return Q.getLookup<ClientTableRow>('Data.ClientTable');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            TableSchema = "TableSchema",
            Tablename = "Tablename",
            FullName = "FullName",
            Identifier = "Identifier",
            DisplayName = "DisplayName",
            InstanceName = "InstanceName",
            ImportedTable = "ImportedTable",
            ReadPermission = "ReadPermission",
            ModifyPermission = "ModifyPermission",
            IdFieldName = "IdFieldName",
            NameFieldName = "NameFieldName",
            DisplayOrderField = "DisplayOrderField",
            LookupScript = "LookupScript",
            LookupPermission = "LookupPermission",
            NavigationPath = "NavigationPath",
            NavigationOrder = "NavigationOrder",
            NavigationIcon = "NavigationIcon",
            Extends = "Extends",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ClientFields = "ClientFields"
        }
    }
}
